import { relation, text } from '@nozbe/watermelondb/decorators';
import { CASHBOOK_CATEGORIES } from '../schema';
import { Model } from '@nozbe/watermelondb';

export default class CashbookCategories extends Model {
    static table = CASHBOOK_CATEGORIES;

    static associations = {
        business: { type: 'belongs_to', key: 'business_id' },
    }

    @text('name') name;

    @relation('business', 'business_id') business;
};